module.exports = __webpack_public_path__ + "static/media/icn_kyc_incomplete.13924be5.svg";